import React from "react";
import { Icon } from "components";
import { Avatar, Badge } from "e100-react-components";
import { IPropTypes as AvatarProps } from "e100-react-components/lib/components/Avatar/index";
import { useStyles } from "./styles";
import { ACTIVE_STATUS } from "shared/constants/obu";

export interface CarAvatarProps {
  kind: string;
  activeStatus?: ACTIVE_STATUS | -1;
  invisibleBadge?: boolean;
  avatarSize?: AvatarProps["size"];
}

export const CarAvatar = ({
  activeStatus,
  kind,
  invisibleBadge,
  avatarSize
}: CarAvatarProps) => {
  const classes = useStyles({
    autoActiveStatus: activeStatus || -1,
    avatarSize
  });
  return (
    <Badge
      overlap="circle"
      anchorOrigin={{
        horizontal: "right",
        vertical: "top",
      }}
      variant="dot"
      classes={{
        badge: classes.badge,
      }}
      invisible={invisibleBadge}
    >
      <Avatar
        size={avatarSize || "medium"}
        classes={{
          root: classes.avatar,
        }}
      >
        <Icon kind={kind} />
      </Avatar>
    </Badge>
  );
};
